// extracted by mini-css-extract-plugin
module.exports = {"root":"SubHeaderPanel_root__SW8vz","divider":"SubHeaderPanel_divider__Z6uEr"};